<template>
  <div :class="$attrs.class">
    <div class="lg:tw-flex tw-mb-12 tw-px-8" v-if="props.order">
      <div class="lg:tw-w-1/2 lg:tw-mr-8">
        <h2 class="tw-font-black tw-text-5xl tw-text-red-medium tw-mb-2" v-if="order.time_cancelled">
          Canceled
        </h2>
        <h2 class="tw-font-black tw-text-4xl" v-if="order.catering_order != null && order.catering_order.event_type">Event: {{order.catering_order.event_type}}</h2>
        <h2 class="tw-font-black tw-text-4xl" v-else></h2>
        
        <p class="tw-mb-4">
          {{orderDate}}
        </p>

        <h4 class="tw-text-2xl tw-font-black">{{orderHeadline}}</h4>

        <template v-if="(order.deliverymode == 'delivery' || order.deliverymode == 'dispatch') && order.delivery_street1 != null" >
          <p class="tw-mb-4">
            to {{order.delivery_street1}}
          </p>
        </template>
        <template v-else-if="orderLocation">
          <p class="tw-mb-4">
            Piada {{orderLocation.name}}<br/>
            {{orderLocation.streetaddress}}<br/>
            {{orderLocation.city}}, {{orderLocation.state}} {{orderLocation.zip}}
          </p>
        </template>

        <template v-if="order.catering_order != null && order.catering_order.contact_name != null">
          
          <h4 class="tw-text-2xl tw-font-black">Contact:</h4>
          <p>
            {{order.catering_order.contact_name}}
          </p>
        </template>

      </div>
      
      <div class="lg:tw-w-1/2 lg:tw-ml-8">
        <h2 class="tw-font-black tw-text-4xl">Guest Information</h2>

        <p class="tw-mb-4" v-if="order.catering_order != null && order.catering_order.guest_count">
          {{order.catering_order.guest_count}} 
          <!-- @vue-skip -->
          {{pluralizeProductName('guest', order.catering_order.guest_count)}}
        </p>
        <p class="tw-mb-4" v-else>
          Guest count not listed
        </p>

        <h4 class="tw-text-2xl tw-font-black">Guest Allergies</h4>
        <p class="tw-mb-4" v-if="order.catering_order != null && order.catering_order.allergens != null && order.catering_order.allergens.length > 0">
          {{order.catering_order.allergens.join(', ')}}
        </p>
        <p class="tw-mb-4" v-else>
          None listed
        </p>


        <h4 class="tw-text-2xl tw-font-black">Guest Diets</h4>
        <p class="tw-mb-4" v-if="order.catering_order != null && order.catering_order.diets != null && order.catering_order.diets.length > 0">
          {{order.catering_order.diets.join(', ')}}
        </p>
        <p class="tw-mb-4" v-else>
          None listed
        </p>
      </div>
    </div>

    <div class="tw-w-full tw-px-8" v-if="props.order">

      <table class="tw-table-fixed tw-w-full tw-mb-8">
          <tbody>
            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Order Type
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4 tw-capitalize">
                {{order.deliverymode}}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Order ID
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                {{order.oloid}}
              </td>
            </tr>

            <template v-if="order.time_cancelled">
              <tr>
                <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                  Canceled At
                </td>
                <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                  {{ DateTime.fromISO(order.time_cancelled).toFormat('MMMM d, yyyy h:mm a') }}
                </td>
              </tr>
            </template>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Subtotal
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order.subtotal ? order.subtotal.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00' }}
              </td>
            </tr>

            <tr v-if="order && order.tip">
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Tip
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order && order.tip ? order.tip.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
              </td>
            </tr>

            <tr v-if="order && order.customerhandoffcharge">
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Delivery Fee
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order && order.customerhandoffcharge ? order.customerhandoffcharge.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Discounts
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                <span v-if="order.discount && order.discount > 0">-</span>
                ${{order.discount ? order.discount.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00' }}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Tax
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order.totalTaxes() ? (order.totalTaxes()).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}
              </td>
            </tr>
        
            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Total
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order.total ? order.total.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00' }}
              </td>
            </tr>
          </tbody>
        </table>

      <p v-if="props.order.fired && props.order.upcoming" class="tw-text-orange-medium tw-font-bold tw-italic tw-mt-2 tw-text-2xl">
        This order is being prepared
      </p>

      <h2 class="tw-font-black tw-text-2xl tw-mb-8 tw-mt-16">Items Ordered</h2>

      <bagProduct
        class="tw-w-full tw-mb-4 tw-bg-white tw-shadow-xl tw-rounded-2xl"
        v-for="product in order.products"
        :actions="false"
        :size="'confirmation'"
        :key="'bp-'+product.chainproductid.toString()"
        :product="product" />

      <div class="tw-mt-16">
        <template v-if="order.upcoming">
          <div class="tw-mb-8 tw-text-center tw-text-orange-medium tw-font-bold">
            <p v-if="order.editable && !isEditingOrder">
              This order can be edited until {{ editOrderCutoffTime ? editOrderCutoffTime : ' the previous order starts being prepared ' }}. When you edit an order, the original order will still be prepared by the restaurant without changes unless the new order is placed. You must place the new order for the original order to be canceled.
            </p>
            <p v-else-if="isEditingOrder">This order is currently being edited.</p>
            <p v-else>This order cannot be edited. To make changes to your order, please cancel this order, and re-order your order from the "Previous Orders" section, or contact a catering representative at 1.855.MYPIADA</p>
          </div>
          <div class="tw-w-1/2 tw-inline-block tw-px-2">
            <TwButton
              cssClass="tw-external-input-btn tw-w-full tw-ml-0 md:tw-mr-auto md:tw-ml-auto xl:tw-mr-auto xl:tw-ml-0 2xl:tw-mr-auto 2xl:tw-ml-auto tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white tw-text-lg 2xl:tw-text-2xl enabled:hover:tw-bg-black enabled:hover:tw-border-black tw-font-bold md:tw-px-1 tw-px-4 2xl:tw-px-4 tw-py-3 2xl:tw-py-4 tw-transition-all tw-duration-200 tw-rounded-full"
              @click="editOrderClick"
              :isLoading="props.loading"
              :isDisabled="props.loading || !order.editable || !order.upcoming || isEditingOrder"
              :buttonText="'Edit Order'" />
          </div>
          <div class="tw-w-1/2 tw-inline-block tw-px-2">
            <TwButton
            cssClass="tw-external-input-btn tw-w-full tw-ml-0 md:tw-mr-auto md:tw-ml-auto xl:tw-mr-auto xl:tw-ml-0 2xl:tw-mr-auto 2xl:tw-ml-auto tw-bg-white tw-border-2 tw-border-black tw-text-black tw-text-lg 2xl:tw-text-2xl hover:tw-bg-black hover:tw-border-black hover:tw-text-white tw-font-bold md:tw-px-1 tw-px-4 2xl:tw-px-4 tw-py-3 2xl:tw-py-4 tw-transition-all tw-duration-200 tw-rounded-full"
            @click="cancelOrderClick"
            :isLoading="props.loading"
            :isDisabled="props.loading || !order.upcoming"
            :buttonText="'Cancel Order'" />
          </div>
        </template>
        <template v-else>
          <TwButton
          cssClass="tw-external-input-btn tw-w-full tw-ml-0 md:tw-mr-auto md:tw-ml-auto xl:tw-mr-auto xl:tw-ml-0 2xl:tw-mr-auto 2xl:tw-ml-auto tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white tw-text-lg 2xl:tw-text-2xl hover:tw-bg-black hover:tw-border-black tw-font-bold tw-px-8 2xl:tw-px-10 tw-py-3 2xl:tw-py-4 tw-transition-all tw-duration-200 tw-rounded-full"
          @click="reorderRecentOrderClick"
          :isLoading="props.loading"
          :isDisabled="props.loading || order.upcoming"
          :buttonText="reorderButtonText" />
        </template>
        <div class="tw-px-8 tw-mt-8 tw-text-xl tw-italic tw-font-bold tw-text-center">
          Catering orders that are canceled with less than a three-hour notice will be charged a cancelation fee of 50% of the order total.
        </div>
      </div>
    </div>
  </div>

  <TwModal
      v-show="confirmModalOpen"
      :hasAccept="true"
      :hasHeader="false"
      :modalSize="'small'"
      @emitClose="closeConfirmModal">

      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Are you sure you want to continue?</h2>
          <button
            type="button"
            class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
            @click="closeConfirmModal"
          >
            &times;
          </button>
        </div>
        <p class="tw-mx-8 tw-text-3xl !tw-leading-relaxed">
          {{ modalText }}
        </p>
      </template>
      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8 lg:tw-mb-4">
          <TwButton 
            cssClass="tw-border-2 tw-bg-orange-medium tw-border-orange-medium tw-text-white enabled:hover:tw-bg-black enabled:hover:tw-border-black hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="confirmModalClick" 
            :isLoading="false"
            :isDisabled="cancelingOrder && !props.order.cancellable" 
            :buttonText="modalButtonText"/>

          <TwButton
            cssClass="tw-border-2 tw-bg-white tw-border-black tw-text-black hover:tw-bg-black hover:tw-border-black hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-rounded-full"
            @emit-click="closeConfirmModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Nevermind'"/>
        </div>
      </template>
    </TwModal>

</template>


<script setup lang="ts">
  import { ref, onMounted, computed, getCurrentInstance } from 'vue'
  import TwButton from '../../components/TwButton.vue';
  import TwModal from '../../components/TwModal.vue';

  import bagProduct from '../bag/_BagProduct.vue';

  import type OrderDetails from '../../classes/OrderDetails';
  import type Location from '../../classes/Location';

  import { DateTime } from "luxon";
  const props = defineProps<{ order: OrderDetails, locations: Location[], loading: boolean, editingOrder: number}>();
  const emit = defineEmits(['handleReorderRecentOrderClick', 'handleEditOrderClick', 'handleCancelOrderClick']);

  const reorderingRecentOrder = ref(false);
  const editingOrder = ref(false);
  const cancelingOrder = ref(false);
  const confirmModalOpen = ref(false);

  const orderDate = computed(() => {
    let dt = '';

    if (props.order?.readytime != null) {
      let ready = DateTime.fromFormat(props.order.readytime, 'yyyyMMdd HH:mm');

      dt = ready.toFormat('EEEE, MMM d') + ' at ' + ready.toFormat('h:mma');
    }

    return dt;
  })

  const orderLocation = computed(() => {
    let location: (Location | undefined) = undefined;

    if (props.locations && props.locations.length > 0) {
      location = props.locations.find((loc: Location) => {
        return loc.id == props.order.vendorid
      });
    }

    return location
  })

  // Not worth trying to do this one liner in the template so just concate it here
  const orderHeadline = computed(() => {
    let title = ''

    switch(props.order.deliverymode) {
      case 'pickup':
        title += 'Pick up from '
        break;
      case 'drivethru':
        title += 'Drivethru at '
        break;
      case 'curbside':
        title += 'Curbside at '
        break;
      case 'dispatch':
        title += 'Delivery from '
        break;
      default:
        title += 'Pick up from '
    }

    return title
  })

  const isEditingOrder = computed(() => {
    return props.order.catering_order.id == props.editingOrder
  })

  const reorderButtonText = computed(() => {
    return "Re-Order - $" + (props.order.total).toLocaleString("en-US", {minimumFractionDigits: 2})
  })

  const reorderRecentOrderClick = (() => {
    reorderingRecentOrder.value = true;
    confirmModalOpen.value = true;
  })
  const editOrderClick = (() => {
    editingOrder.value = true;
    confirmModalOpen.value = true;
  })

  const cancelOrderClick = (() => {
    cancelingOrder.value = true;
    confirmModalOpen.value = true;
  })

  const modalButtonText = computed(() => {
    let text = '';

    if (reorderingRecentOrder.value) {
      text = 'Confirm Re-Order'
    } else if (editingOrder.value) {
      text = 'Continue to Edit Order'
    } else if (cancelingOrder.value) {
      text = 'Confirm Cancel Order'
    }

    return text
  })

  const modalText = computed(() => {
    let text = '';
    if (reorderingRecentOrder.value) {
      text = 'If you continue with re-ordering a previous order, your current bag will be cleared out. This cannot be undone.'
    } else if (editingOrder.value) {
      text = 'If you continue with editing this order, your current bag will be cleared out. This cannot be undone. You must place the edited order or the original order will still be prepared without any changes.'
    } else if (cancelingOrder.value) {
      if (props.order.cancellable) {
        text = 'If you continue with cancelling this order, your food will not be prepared and your payment method will be refunded. A cancellation fee of 50% of the order total will be charged for orders cancelled with less than a three-hour notice. This cannot be undone.'
      } else {
        text = 'This order cannot be cancelled. If you need assistance, please contact a catering representative at 1.855.MYPIADA. A cancellation fee of 50% of the order total will be charged for orders cancelled with less than a three-hour notice.'
      }
    }

    return "" + text + " "
  })

  const confirmModalClick = (() => {
    if (reorderingRecentOrder.value) {
      emit('handleReorderRecentOrderClick', props.order)
    } else if (editingOrder.value) {
      emit('handleEditOrderClick', props.order)
    } else if (cancelingOrder.value) {
      emit('handleCancelOrderClick', props.order)
    }
    closeConfirmModal();
  })

  const closeConfirmModal = (() => {
    confirmModalOpen.value = false;
    window.setTimeout(function() {
      reorderingRecentOrder.value = false;
      editingOrder.value = false;
      cancelingOrder.value = false;
    }, 500);
  })

  const editOrderCutoffTime = computed(() => {
    let cutoff = ""
    if (props.order.edit_cutoff_time) {
      let cutoffTime = props.order.edit_cutoff_time;
      let dt = DateTime.fromISO(cutoffTime);
      cutoff = dt.toFormat('LLLL d') + nth(dt.day) + ' at ' + dt.toFormat('h:mma')
    }

    return cutoff
  })

  const nth = (number: number) => {
  if (number > 3 && number < 21) return "th";
  switch (number % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
</script>